import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import WrappedCodeInput from './WrappedCodeInput';

function FormCodeInput(props) {
  return (
    <Field name={props.name} validate={props.validate}>
      {({ input, meta }) => (
        <WrappedCodeInput 
          {...props} 
          input={input} 
          meta={meta} 
          value={input.value !== undefined && input.value !== null ? input.value : ''}
          onChange={(val) => {
            const cleanVal = val && val.target ? val.target.value : val;
            input.onChange(cleanVal);
          }} 
        />
      )}
    </Field>
  );
}

FormCodeInput.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func
};

export default FormCodeInput;
